import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import '../styles/Navbar.css';
import logo from '../assets/logoNome.png';

function Navbar() {
  const location = useLocation();
  const navigate = useNavigate(); // Usando useNavigate para navegação programática

  const handleScrollToTop = () => {
    if (location.pathname !== '/') {
      navigate('/'); // Redireciona para a home
    }
    window.scrollTo(0, 0); // Rola para o topo da página
  };

  const handleScrollToAccordion = () => {
    setTimeout(() => {
      const accordion = document.getElementById('about');
      if (accordion) {
        accordion.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  const handleScrollToContactSection = () => {
    // Disparar evento do Pixel
    if (window.fbq) {
      window.fbq('track', 'Contact'); // Dispara o evento "Contact" no Pixel
    }

    // Rolagem suave para a seção "Contato"
    setTimeout(() => {
      const accordion = document.getElementById('contact');
      if (accordion) {
        accordion.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  return (
    <nav className="navbar">
      <div className="logo" onClick={handleScrollToTop}>
        <img src={logo} alt="Logo" />
      </div>
      <ul className="nav-links">
        <li>
          <Link to="/" onClick={handleScrollToTop}>Home</Link>
        </li>
        <li>
          <Link to="/" onClick={handleScrollToAccordion}>Sobre</Link>
        </li>
        <li>
          <Link to="/" onClick={handleScrollToContactSection}>Contato</Link>
        </li>
      </ul>
    </nav>
  );
}

export default Navbar;
